import { Plus } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { Eyebrow } from "../components/Eyebrow";
import { VideoBackdrop } from "../components/VideoBackdrop";
import { REAL_ESTATE_CATEGORIES, REALESTATE_VIDEO } from "../data/site";

function CategoryItem({ cat, onOpen }) {
  return (
    <li>
      <button
        type="button"
        data-testid={`real-estate-${cat.label}`}
        onClick={() => onOpen(cat)}
        aria-haspopup="dialog"
        aria-label={`View ${cat.label} properties`}
        className="group inline-flex items-center gap-2 text-[1.25rem] font-medium tracking-tight text-[#DCD7C9] transition-colors duration-300 hover:text-[#A27B5B] sm:text-[1.35rem]"
      >
        {cat.label}
        <Plus className="h-4 w-4 text-[#A27B5B] transition-transform duration-300 group-hover:rotate-90" />
      </button>
    </li>
  );
}

export function RealEstateSection({ onOpenCategory }) {
  return (
    <section
      data-testid="real-estate-section"
      className="relative isolate flex min-h-[80vh] items-center overflow-hidden bg-[#141414] py-[112px] sm:py-[160px]"
    >
      {/* Looping moody road video, left-weighted scrim lets it show through */}
      <VideoBackdrop
        src={REALESTATE_VIDEO}
        testId="real-estate-video"
        layerClass="-z-10"
        overlayClass="-z-10 bg-gradient-to-r from-[#141414]/75 via-[#141414]/50 to-[#141414]/25"
      />

      <div className="mx-auto w-full max-w-[760px] px-6 sm:px-8">
        <Reveal data-testid="item-real-estate">
          <Eyebrow as="h2" dark>Investing in real estate</Eyebrow>
          <div className="mt-7 space-y-6 text-[1.18rem] leading-[1.65] text-[#DCD7C9] sm:text-[1.35rem]">
            <p>
              We believe great spaces are created through vision,
              thoughtful stewardship, and a long-term perspective.
            </p>
            <p className="font-bold text-[#A27B5B]">
              That’s what gets our attention.
            </p>
            <p>
              Today, we own and develop many kinds of property, most of it
              in British Columbia, though a good opportunity doesn’t always
              respect a map. We take our time, and build with the next
              decade in mind rather than the next sale.
            </p>
            <p>
              Like our business investments, we move carefully, think long
              term, and pursue values-forward projects. Whether we’re
              investing in an existing property or helping bring a new one
              to life, we’re drawn to opportunities with lasting potential.
            </p>
          </div>
        </Reveal>

        <Reveal className="mt-[88px] sm:mt-[112px]" delay={80}>
          <ul
            data-testid="real-estate-categories"
            className="flex flex-col gap-y-6 sm:flex-row sm:items-center sm:justify-between sm:gap-x-8"
          >
            {REAL_ESTATE_CATEGORIES.map((cat) => (
              <CategoryItem key={cat.label} cat={cat} onOpen={onOpenCategory} />
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
}
